import { error } from '../Logging'

let provider

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const setAnalyticsLayer = (instance, overrideIfExists = false) => {
  if (provider && !overrideIfExists) {
    console.warn('Analytics provider has already been set, ignoring.')
    return
  }
  provider = instance
}

const perform = (op, ...args) => {
  if (provider) {
    if (provider[op] && typeof provider[op] === 'function') {
      return provider[op](...args)
    }
    error(`Analytics provider does not support method '${op}'.`)
    return false
  }
  error(`Analytics provider has not been set. Ignoring call to '${op}'.`)
  return false
}

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const track = perform.bind(this, 'track')
